import { toast } from "sonner";

interface ServerError {
  errorCode?: string;
  errorName?: string;
  message: string;
  requestId?: string | null;
  status?: string;
  statusCode?: number;
  timestamp?: string;
}

export const showErrorToast = (errors: ServerError) => {
  const { message = "알 수 없는 오류가 발생했습니다.", requestId = "" } = errors;

  toast.error(message, {
    id: "error-toast",
    description: requestId ? `Request ID: ${requestId}` : undefined,
    duration: 3000,
  });
};
